module.exports = __webpack_public_path__ + "0b98af032d574997b06e575980fecc36.svg";